// An `OverlayView` which adds a semi-transparent layer over the map to make icons more visible
export default () => {
  class TintOverlayView extends google.maps.OverlayView  {
    constructor() {
      super();
    }

    onAdd() {
      const div = document.createElement('div');
      div.className = "tw:bg-primary-900";
      div.style.position = 'absolute';
      div.style.opacity = 0.4
      div.style.pointerEvents = 'none';

      this.getPanes().overlayLayer.appendChild(div);
      this.div = div;
    }

    draw() {
      const projection = this.getProjection();
      const bounds = projection.getVisibleRegion().latLngBounds;

      if (!bounds) return;

      const sw = projection.fromLatLngToDivPixel(bounds.getSouthWest());
      const ne = projection.fromLatLngToDivPixel(bounds.getNorthEast());

      const div = this.div;
      div.style.left = `${sw.x}px`;
      div.style.top = `${ne.y}px`;
      div.style.width = `${ne.x - sw.x}px`;
      div.style.height = `${sw.y - ne.y}px`;
    }

    onRemove() {
      this.div.parentNode.removeChild(this.div);
    }
  }

  return new TintOverlayView()
}
